var red = {
  red1: 'hsl(347 100% 99.0%)',
  red2: 'hsl(348 100% 99.0%)',
  red3: 'hsl(348 99.7% 97.2%)',
  red4: 'hsl(348 92.2% 94.5%)',
  red5: 'hsl(348 83.3% 90.1%)',
  red6: 'hsl(348 75.7% 84.0%)',
  red7: 'hsl(347 71.9% 78.7%)',
  red8: 'hsl(347 100% 67.0%)',
  red9: 'hsl(347, 100%, 60.0%)',
  red10: 'hsl(347 77.4% 52.4%)',
  red11: 'hsl(347, 80.0%, 40.0%)',
  red12: 'hsl(347 60.0% 15.0%)'
};
var redA = {
  redA1: 'hsl(348 100% 51.0% / 0.020)',
  redA2: 'hsl(348 100% 51.0% / 0.020)',
  redA3: 'hsl(347 100% 50.1% / 0.055)',
  redA4: 'hsl(348 99.8% 48.2% / 0.106)',
  redA5: 'hsl(349 99.3% 45.8% / 0.181)',
  redA6: 'hsl(347 99.5% 43.2% / 0.283)',
  redA7: 'hsl(347 99.8% 42.0% / 0.365)',
  redA8: 'hsl(347 100% 50% / 0.641)',
  redA9: 'hsl(347 100% 50.0% / 0.800)',
  redA10: 'hsl(347 99.8% 43.8% / 0.844)',
  redA11: 'hsl(347 99.9% 34.9% / 0.922)',
  redA12: 'hsl(347 99.1% 9.7% / 0.942)'
};
var redDark = {
  red1: 'hsl(347 23.0% 10.0%)',
  red2: 'hsl(346 34.4% 12.0%)',
  red3: 'hsl(345 42.6% 16.5%)',
  red4: 'hsl(345 46.5% 19.3%)',
  red5: 'hsl(346 49.9% 22.1%)',
  red6: 'hsl(346 53.9% 26.2%)',
  red7: 'hsl(346 59.0% 32.3%)',
  red8: 'hsl(347 64.8% 41.2%)',
  red9: 'hsl(347, 100%, 60.0%)',
  red10: 'hsl(347, 100%, 67.0%)',
  red11: 'hsl(347 100% 72.0%)',
  red12: 'hsl(347 100% 98.0%)'
};
var redDarkA = {
  redA1: 'hsl(0 0% 0% / 0)',
  redA2: 'hsl(342 98.5% 53.6% / 0.045)',
  redA3: 'hsl(344 99.1% 59.8% / 0.130)',
  redA4: 'hsl(343 98.8% 60.1% / 0.184)',
  redA5: 'hsl(346 99.6% 60.5% / 0.237)',
  redA6: 'hsl(345 99.6% 60.5% / 0.322)',
  redA7: 'hsl(346 99.7% 60.0% / 0.447)',
  redA8: 'hsl(347 100% 59.2% / 0.634)',
  redA9: 'hsl(347 100% 60.1% / 0.980)',
  redA10: 'hsl(347 100% 67.3% / 0.980)',
  redA11: 'hsl(347 100% 72.3% / 0.980)',
  redA12: 'hsl(338 100% 98.9% / 0.980)'
};

export { red, redA, redDark, redDarkA };
